import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IInvoice extends BaseEntity {
    name: string;
    totalAmount: number;
    lines: IInvoiceLine[];
    hasUnpaid: boolean = false;
    twinfieldNumber: number;
    account: any;
    description: string;
    date: Date;
}

export class IInvoiceLine extends BaseEntity {
    description: string;
    count: number;
    amountPerUnit: number;
    totalAmount: number;
    employee: any;
    article?: string;
    linenumber?: number;
}

export class IInvoiceGroup {
    invoiceId: string;
    invoiceNumber: string;
    twinfieldNumber: string;
    invoiceDate: Date;
    totalAmount: number;
    lines: IInvoiceLine[];
}

export class IEmployeeInvoiceSummary {
    employee: any;
    totalHours: number;
    totalAmount: number;
    invoiceCount: number;
    invoiceGroups: IInvoiceGroup[];
}

export class IInvoiceSummary {
    account: any;
    employeeSummaries: IEmployeeInvoiceSummary[];
    totalAmount: number;
    totalInvoiceCount: number;
}

export interface IInvoiceComparison {
    invoiceId: string;
    invoiceNumber: string;
    invoiceDate: string;
    account: any;
    description: string;
    currentTotal: number;
    recalculatedTotal: number;
    difference: number;
    currentLines?: IInvoiceLine[];
    recalculatedLines?: IInvoiceLine[];
}

export interface IGrossAllowanceInvoiceAudit {
    invoiceId: string;
    invoiceNumber: string;
    invoiceDate: string;
    invoicedBruto: number;
    expectedBruto: number;
}

export interface IGrossAllowanceAccountAudit {
    account: any;
    shouldChargeOnInvoice: boolean;
    caoBrutoPercentage: number;
    invoicedBrutoTotal: number;
    expectedBrutoTotal: number;
    difference: number;
    status: string;
    invoiceCount: number;
    invoices: IGrossAllowanceInvoiceAudit[];
    expanded?: boolean;
}

export class InvoicesService extends BaseService<IInvoice> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'finance/invoice');
    }

    public getSummary = (from?: Date, till?: Date, employeeType?: string): ng.IPromise<IInvoiceSummary[]> => {
        return this.Restangular.all(this.itemName + '/summary').customGET('', { 
            from: from, 
            till: till,
            employeeType: employeeType || 'all'
        }).then((response: Restangular.ICollection) => {
            if (response && response.plain) {
                return response.plain();
            } else {
                return [];
            }
        });
    }

    public getComparison = (from?: Date, till?: Date): ng.IPromise<IInvoiceComparison[]> => {
        return this.Restangular.all(this.itemName + '/comparison').customGET('', {
            from: from,
            till: till
        }).then((response: Restangular.ICollection) => {
            if (response && response.plain) {
                return response.plain();
            } else {
                return [];
            }
        });
    }

    public getGrossAllowanceAudit = (from?: Date, till?: Date): ng.IPromise<IGrossAllowanceAccountAudit[]> => {
        return this.Restangular.all(this.itemName + '/gross-allowance-audit').customGET('', {
            from: from,
            till: till
        }).then((response: Restangular.ICollection) => {
            if (response && response.plain) {
                return response.plain();
            } else {
                return [];
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/invoices.service.ts